const mapStateToProps = state => 
    ({
        step: state.solicitudEmpadronamientoExtranjero.step,
        data: state.solicitudEmpadronamientoExtranjero.data,
        datosCiudadanoTable: state.solicitudEmpadronamientoExtranjero.datosCiudadanoTable,
        currentUser: state.security.currentUser,
        datosEmpadronador: state.solicitudEmpadronamientoExtranjero.datosEmpadronador,
        datosSolicitudExtranjero: state.solicitudEmpadronamientoExtranjero.datosSolicitudExtranjero,
        nroBoleta: state.solicitudEmpadronamientoExtranjero.nroBoleta,
        datosIdentidadFoto: state.solicitudEmpadronamientoExtranjero.datosIdentidadFoto,
        datoIdentidadFotoIngresada: state.solicitudEmpadronamientoExtranjero.datoIdentidadFotoIngresada,
        datosGeneralesDelCiudadano: state.solicitudEmpadronamientoExtranjero.datosGeneralesDelCiudadano,
    });
export default mapStateToProps;
